export const ITEM_ATTRIBUTES = {
  COUNTABLE: 1,
  CONSUMABLE: 2,
  USABLE_OVERWORLD: 3,
  USABLE_IN_BATTLE: 4,
  HOLDABLE: 5,
  HOLDABLE_PASSIVE: 6,
  HOLDABLE_ACTIVE: 7,
  UNDERGROUND: 8,
} as const;

export const ITEM_CATEGORIES = {
  STAT_BOOSTS: 1,
  EFFORT_DROP: 2,
  MEDICINE: 3,
  OTHER: 4,
  IN_A_PINCH: 5,
  PICKY_HEALING: 6,
  TYPE_PROTECTION: 7,
  BAKING_ONLY: 8,
  COLLECTIBLES: 9,
  EVOLUTION: 10,
  SPELUNKING: 11,
  HELD_ITEMS: 12,
  CHOICE: 13,
  EFFORT_TRAINING: 14,
  BAD_HELD_ITEMS: 15,
  TRAINING: 16,
  PLATES: 17,
  SPECIES_SPECIFIC: 18,
  TYPE_ENHANCEMENT: 19,
  EVENT_ITEMS: 20,
  GAMEPLAY: 21,
  PLOT_ADVANCEMENT: 22,
  UNUSED: 23,
  LOOT: 24,
  ALL_MAIL: 25,
  VITAMINS: 26,
  HEALING: 27,
  PP_RECOVERY: 28,
  REVIVAL: 29,
  STATUS_CURES: 30,
  MULCH: 32,
  SPECIAL_BALLS: 33,
  STANDARD_BALLS: 34,
  DEX_COMPLETION: 35,
  SCARVES: 36,
  ALL_MACHINES: 37,
  FLUTES: 38,
  APRICORN_BALLS: 39,
  APRICORN_BOX: 40,
  DATA_CARDS: 41,
  JEWELS: 42,
  MIRACLE_SHOOTER: 43,
  MEGA_STONES: 44,
  MEMORIES: 45,
  Z_CRYSTALS: 46,
  SPECIES_CANDIES: 47,
  CATCHING_BONUS: 48,
  DYNAMAX_CRYSTALS: 49,
  NATURE_MINTS: 50,
  CURRY_INGREDIENTS: 51,
  TERA_SHARD: 52,
  SANDWICH_INGREDIENTS: 53,
  TM_MATERIALS: 54,
  PICNIC: 55,
  /**
   * @deprecated Misspelled: the endpoint names this `dynamax-crystals`.
   *   Use {@link ITEM_CATEGORIES.DYNAMAX_CRYSTALS}. Removed in 3.0.
   */
  DYNAMAX_CRISTALS: 49,
} as const;

export const ITEM_FLING_EFFECTS = {
  BADLY_POISON: 1,
  BURN: 2,
  BERRY_EFFECT: 3,
  HERB_EFFECT: 4,
  PARALYZE: 5,
  POISON: 6,
  FLINCH: 7,
} as const;

export const ITEM_POCKETS = {
  MISC: 1,
  MEDICINE: 2,
  POKEBALLS: 3,
  MACHINES: 4,
  BERRIES: 5,
  MAIL: 6,
  BATTLE: 7,
  KEY: 8,
} as const;
